import { classNames } from 'primereact/utils';
import React from 'react';

const C2Columns = (props) => {
    const { children, className } = props;
    const classNamez = classNames(className, { "grid grid-nogutter": true });
    return (React.createElement("div", Object.assign({}, props, { className: classNamez }), children));
};

export { C2Columns };
//# sourceMappingURL=C2Columns.js.map
